import React from 'react'

const HeaderTwoTop = () => {
  return (
    <div className="header-top-bar text-white d-none d-sm-block">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-9 col-sm-9">
                        <ul className="top-left-content">
                            <li><i className="flaticon-map"></i>Al durrah tower, 9th floor, majaz 3 Sharjah</li>
                            <li><i className="flaticon-call"></i>+971502033924</li>
                            
                        </ul>
                    </div>
                    <div className="col-lg-2 col-sm-3 text-end">
                        <div className="top-social-icons">
                             <a href="https://www.facebook.com/profile.php?id=61575105304065" target="_blank" rel="noopener noreferrer">
    <i className="fab fa-facebook-f"></i>
  </a>

  <a href="https://wa.me/9710502033924" target="_blank" rel="noopener noreferrer">
    <i className="fab fa-whatsapp"></i>
  </a>

  <a href="https://www.instagram.com/diamond_houseuae/" target="_blank" rel="noopener noreferrer">
    <i className="fab fa-instagram"></i>
  </a>

  <a href="https://www.linkedin.com/company/diamond-house-technical-services/posts/?feedView=all" target="_blank" rel="noopener noreferrer">
    <i className="fab fa-linkedin-in"></i>
  </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  )
}

export default HeaderTwoTop